// Este arquivo é responsável por fazer a requisição para a API externa do ViaCEP, que retorna os dados de endereço a partir do CEP informado.

export const getExternalAddress = async ({ q }) => {
  const url = `https://viacep.com.br/ws/${q}/json/`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    throw new TypeError("Resposta não é JSON!");
  }

  const responseJson = await response.json();

  if (!response.ok) {
    throw new Error(`Error ${response.status}: ${responseJson.error}`);
  }
  
  return responseJson;
};

